import { useGetSettingQuery } from '../../../api/core'

export const useOpenGamesSetting = () => {
  return useGetSettingQuery('open_games')
}
